export const CanvasEditor = {
  position: 'fixed',
  inset: '0',
  pointerEvents: 'none',
  zIndex: 100,
  fontSize: 'Z1',

  DropOverlay: {
    if: (el) => Boolean(el.getRootContext('methods')?.sdk)
  },
  TutorialGifNotification: null,
  TutorialGifsNotificationStack: null,
  Chosen: null,
  QuickEditor: {
    pointerEvents: 'auto',
    if: (el) => !el.call('isCanvasV2')
  },
  DynamicIsland: null,
  MainCanvasNavbar: null,

  Tabs: null,
  ComponentFrameCanvasTooltip: null,
  FloatingPanel: null,
  LoadingGifSection: null,
  ContextMenu: {},

  CanvasOverlay: {},

  CommandBar: null,

  Zoombar: {
    fontSize: 'Z1',
    position: 'absolute',
    bottom: 'X2',
    right: 'X2',
    top: 'auto',
    width: 'auto',
    pointerEvents: 'auto',
    NavbarButtonSet: {
      // Hook the Settings button into the unified SettingsModal instead
      // of the legacy `/settings` modal routed through `openModal`.
      Settings: {
        onClick: (ev, el, s) => {
          ev.stopPropagation()
          const root = s.root
          if (!root) return
          root.update({ settingsOpen: true, settingsTab: root.settingsTab || 'project' })
        }
      }
    }
  },

  CanvasPromptTextarea: {},

  // Unified settings modal (auto-extends from the registered SettingsModal
  // component) — shared with the workspace page so the Project and
  // Workspace tabs live under a single surface.
  SettingsModal: {},

  // Canvas v2 chrome — selection box, handles, marquee, rulers, snap
  // lines, guides, SelectedNavbar host. All in screen-space px so
  // they don't scale with viewport zoom.
  CanvasOverlayV2: {},

  // Picker overlays — surface-agnostic modals that appear on BOTH
  // /workspaces/<slug> AND /<owner>/<key> project pages without redirect.
  // State lives on s.root (integrationPicker, libraryPickerFor,
  // newProjectPicker) so WorkspaceNavbar's openers write once and either
  // surface reacts.
  IntegrationPickerOverlay: {},
  LibraryPickerOverlay: {},
  // Template-picker modal — opened by WorkspaceNavbar "New project" /
  // "New library" items. State key: root.newProjectPicker.
  NewProjectPickerOverlay: {},
  // MCP connector picker — opened by WorkspaceNavbar "New MCP connector".
  // State keys: root._mcpConnectorPickerOpen, root._mcpConnectorDraft.
  MCPConnectorPickerOverlay: {}
}
